export const CARE_MANAGER_SIGNUP_CITIES = [
  { name: "Bengaluru", state: "Karnataka" },
  { name: "Mumbai", state: "Maharashtra" },
  { name: "Delhi", state: "Delhi" },
  { name: "Kochi", state: "Kerala" },
  { name: "Chennai", state: "Tamil Nadu" },
  { name: "Kolkata", state: "West Bengal" },
  { name: "Pune", state: "Maharashtra" },
  { name: "Hyderabad", state: "Telangana" },
];

export const CARE_MANAGER_LOCALITIES = {
  Bengaluru: ["Indiranagar", "Koramangala", "HSR Layout", "Whitefield", "Jayanagar", "JP Nagar", "Malleshwaram"],
  Mumbai: ["Bandra West", "Andheri West", "Powai", "Goregaon", "Juhu"],
  Delhi: ["Saket", "Vasant Kunj", "Connaught Place", "Karol Bagh", "Hauz Khas"],
  Kochi: ["Kakkanad", "Edappally", "Vyttila", "Fort Kochi"],
  Chennai: ["Adyar", "Velachery", "T Nagar", "Nungambakkam", "Mylapore"],
  Kolkata: ["Salt Lake", "Ballygunge", "New Town", "Park Street"],
  Pune: ["Baner", "Kothrud", "Viman Nagar", "Koregaon Park"],
  Hyderabad: ["Gachibowli", "Madhapur", "Jubilee Hills", "Banjara Hills"],
};

/** Matches signup Step 4 — clinical dispatch specialties. */
export const CARE_MANAGER_SERVICE_OPTIONS = [
  "Elder Care",
  "Home Nursing",
  "ICU at Home",
  "Dementia Care",
  "Parkinson's Care",
  "Stroke Care",
  "Palliative Care",
  "Mother & Baby Care",
  "Child Care",
  "Physiotherapy",
  "Medical Equipment",
];

export const CARE_MANAGER_TYPE_OPTIONS = [
  { value: "INDEPENDENT_PRACTITIONER", label: "Independent Practitioner" },
  { value: "AGENCY_OWNER_SUPERVISOR", label: "Agency Owner / Supervisor" },
  { value: "HOSPITAL_GERIATRIC_COORDINATOR", label: "Hospital Geriatric Coordinator" },
  { value: "HEALTHCARE_NGO_REPRESENTATIVE", label: "Healthcare NGO Representative" },
  { value: "CORPORATE_HEALTHCARE_ORG", label: "Corporate Healthcare Org" },
];

export const CARE_MANAGER_EXPERIENCE_OPTIONS = [
  { value: "0", label: "Less than 1 year" },
  { value: "1", label: "1 Year" },
  { value: "2", label: "2 Years" },
  { value: "3", label: "3 Years" },
  { value: "4", label: "4 Years" },
  { value: "5", label: "5 Years" },
  { value: "7", label: "6–8 Years" },
  { value: "10", label: "9–12 Years" },
  { value: "15", label: "12+ Years" },
];

export const CARE_MANAGER_SIGNUP_TERMS_EXCERPT = `Privacy: You will maintain patient confidentiality in line with applicable clinical privacy principles. EHR and visitation logs are stored only through Nema CareHub. Do not extract or share patient diagnostic metrics outside approved channels.

Section 3 — Caregiver dispatching & coordination: Care Managers must build clinical care plans and match registered caregivers to elders in their service areas. Do not assign caregivers to critical care environments without verified qualifications and Ops-approved documentation.

Section 4 — Platform conduct: Misrepresentation of credentials, bypassing KYC, or dispatch without an active subscription may result in account suspension.

By submitting, you certify that the qualifications and service areas you declare are accurate and that you agree to Nema CareHub clinical quality and privacy policies.`;

export const SIGNUP_STEP_TITLES = {
  1: "Step 1: Account & contact",
  2: "Step 2: Professional Qualifications",
  3: "Step 3: Regional Coverage",
  4: "Step 4: Clinical Services Specialties",
  5: "Step 5: Terms & Regulatory Bindings",
};
